// components/ChangeStatusDropdown.jsx
import React from "react";
import { useDispatch } from "react-redux";
import { updateEmployeeStatus } from "../../redux/actions/employeeActions";
import theme from "../../components/shared/theme";

const statusOptions = ["active", "inactive", "suspended"];

const ChangeStatusDropdown = ({ userId, currentStatus }) => {
  const dispatch = useDispatch();

  const handleChange = (e) => {
    const newStatus = e.target.value;
    if (newStatus !== currentStatus) {
      dispatch(updateEmployeeStatus(userId, newStatus));
    }
  };

  return (
    <select
      value={currentStatus}
      onChange={handleChange}
      style={{
        padding: theme.spacing.xs,
        borderRadius: theme.radius.md,
        border: "1px solid #ccc",
        backgroundColor:
          currentStatus === "active"
            ? "#d4f4dd"
            : currentStatus === "inactive"
            ? "#f4f1d4"
            : "#f4d4d4",
        color: "#000",
      }}
    >
      {statusOptions.map((status) => (
        <option key={status} value={status}>
          {status.charAt(0).toUpperCase() + status.slice(1)}
        </option>
      ))}
    </select>
  );
};

export default ChangeStatusDropdown;
